module.exports = __webpack_public_path__ + "img/ctrl-xx-1.9d0dc100.svg";